import Permissions from '../EditSubSidebar/Permission/index'; // Adjust the import path as needed


import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import InnerSidebar from './InnerSidebar/InnerSidebar';
import "./index.scss";
import EditModule from '..';
import MenuEditor from './edit-side-bar';


const EditSubSidebar = (props: any) => {
  const [selectedComponent, setSelectedComponent] = useState<string>('general');
  const { id } = useParams(); // Fetches the `id` from the route parameters
  console.log("nnn", id)


  const renderComponent = () => {
    switch (selectedComponent) {
      case 'general':
        return (
          <EditModule
            module={props.module}
            primary_key={props.primary_key}
          />
        );
      case 'permissions':
        return (
          <Permissions
            module={props.module}
            primary_key={props.primary_key}
            primary_key_value={id}
          />
        );
        case 'side-bar-editor':
          return (
            <MenuEditor
              // module={props.module}
              // primary_key={props.primary_key}
              // primary_key_value={id}
            />
          );
      default:
        return (
          <EditModule
            module={props.module}
            primary_key={props.primary_key}
          />
        );
    }
  };

  return (
    <>
      {/* <header className="header">
        <h1 className="header-title">Edit Admin User Roles
        </h1>
      </header> */}
      <div className="app-container">
        <InnerSidebar onSelect={setSelectedComponent} />
        <div className="right-side-content">{renderComponent()}</div>
      </div>
    </>
  );
};

export default EditSubSidebar;
